import React, {useEffect, useState} from "react";
import {Field} from "formik";
import {Button, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PRICE_SALE, PRICE_TYPE} from "../../../utils/shared";
import {InputComponent} from "../../../components/elements/Inputs";
import {SelectField} from "../../../components/elements/Inputs/SelectComponent";
import {ButtonAddItem, SecondTrashIcon} from "./FormPresentation";


function FormPrices({indexPresentation, presentation, isView, handleRemovePrice, arrayHelpers, handleAddPrice}) {

  const [optionPrices, setOptionPrices] = useState(PRICE_TYPE);
  const [amount, setAmount] = useState(false);

  useEffect(() => {
    if(!amount){
      setAmount(true)
    }
  }, []);

  useEffect(() => {
    if(amount){
      setOptionAsSelected(null)
    }
  }, [amount]);

  useEffect(() => {
    if(amount){
      setOptionAsSelected(null)
    }
  }, [presentation]);

  const setOptionAsSelected = (itemSelect) => {
    const optionSelected = [itemSelect]
    for (const priceIndex in presentation.prices) {
      if (!["", undefined, null, 0].includes(presentation.prices[priceIndex].price_type)) {
        optionSelected.push(presentation.prices[priceIndex].price_type)
      }
    }
    const newOptions = optionPrices.map(item => {
      item.disabled = optionSelected.includes(item.value)
      return item
    })
    setOptionPrices(newOptions)
  }

  return (
    <div className="!mt-[-2px]">
      <div className="flex justify-between items-center pb-2">
        <Typography variant="h4" className="text-lg font-semibold mt-2">
          Precios
        </Typography>
        <ButtonAddItem
          message={'Añadir precio'}
          addAction={() => handleAddPrice(arrayHelpers)}
          isView={isView || !(presentation?.prices?.length < PRICE_TYPE.length)}
        />
      </div>
      {presentation.prices.map((price, indexPrice) => (
        <div key={indexPrice} className=" flex flex-row">
          <div className="!min-w-[90%] py-2">
            <div className="grid grid-cols-1 xl:lg:2xl:md:grid-cols-2 gap-2 xl:lg:2xl:md:gap-4 items-center border-b">
              <div className="space-y-2">
                <Field
                  defaultOptions={optionPrices}
                  options={optionPrices}
                  callbackOnChange={setOptionAsSelected}
                  component={SelectField}
                  priceTypeSelect={true}
                  menuPlacement="top"
                  name={`presentations[${indexPresentation}].prices[${indexPrice}].price_type`}
                  label="Tipo de precio"
                  disabled={isView || (presentation.prices[indexPrice].price_type === PRICE_SALE)}
                />
              </div>
              <div className="space-y-2 col">
                <InputComponent
                  className="min-w-[100%]"
                  name={`presentations[${indexPresentation}].prices[${indexPrice}].amount`}
                  label="Monto"
                  type="number"
                  disabled={isView}
                />
              </div>
            </div>
          </div>

          <div className="max-w-[10%] flex justify-center content-center mx-auto my-auto">
            <IconButton
              color="red"
              className={`w-8 h-8  ${(presentation.prices[indexPrice].price_type === PRICE_SALE) && 'hidden'} ${isView && 'hidden'}`}
              onClick={() => handleRemovePrice(indexPresentation, arrayHelpers, indexPrice)}
              disabled={isView}>
              <SecondTrashIcon className="w-4 h-4"/>
            </IconButton>
            <button id={`btn-precio-eliminar-${indexPrice}`} type="button" className="hidden" onClick={()=>arrayHelpers.remove(indexPrice)}>eliminarOculto</button>
          </div>
        </div>
      ))}
    </div>

  );
}


export default FormPrices